<div class="cursor-pointer flex gap-3 w-full mobile:block" [class.!block]="mode==='itinerary'">
  <div class="flex gap-3 mobile:w-[calc(100%-1px)]" [class.w-[calc(50%-6px)]]="mode==='create-event'">
    <mat-form-field #start (click)="$event.stopPropagation();picker.open()" appearance="outline"
      [class.ig-field-error]="showStartDateError">
      <mat-label>{{mode==='itinerary'?'Release Date':' Start Date*'}}</mat-label>
      <input matInput [matDatepicker]="picker" (focus)="onFocus()" [formControl]="startControl"
        (dateChange)="onStartDateChange()" [min]="today()">
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field #starttime appearance="outline"
      [class.ig-field-error]="showStartTimeError">
      <mat-label>Time*</mat-label>
      <mat-select (selectionChange)="setFormControlValue1(startControl, startSelect, 'start')" (opened)="onFocus()"
        #startSelect>
        <mat-select-trigger>
          {{getTimeDisplayText(startSelect.value)}}
        </mat-select-trigger>
        <mat-option *ngIf="mode==='create-event'" value="ALL_DAY">All Day</mat-option>
        <mat-option *ngFor="let time of timeValues" [value]="time.value">{{time.text}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex gap-3 mobile:w-[calc(100%-1px)]" [class.w-[calc(50%-6px)]]="mode==='create-event'">
    <mat-form-field #end (click)="$event.stopPropagation();endpicker.open()" appearance="outline"
      [class.ig-field-error]="showEndDateError">
      <mat-label>{{mode==='itinerary'?'Expiry Date':' End Date'}}</mat-label>
      <input matInput [matDatepicker]="endpicker" (focus)="onFocus()" [formControl]="endControl"
        (dateChange)="onEndDateChange()" [min]="startControl?.value">
      <mat-datepicker #endpicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field #endtime appearance="outline"
      [class.ig-field-error]="showEndTimeError">
      <mat-label>Time</mat-label>
      <mat-select (opened)="onFocus()" (selectionChange)="setFormControlValue1(endControl, endSelect, 'end')"
        #endSelect>
        <mat-select-trigger>
          {{getTimeDisplayText(endSelect.value)}}
        </mat-select-trigger>
        <mat-option *ngIf="mode==='create-event'" value="ALL_DAY">All Day</mat-option>
        <mat-option *ngFor="let time of endTimeValues" [value]="time.value">{{time.text}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>